<template>
  <Toast group="device" position="bottom-center" :pt="{ root: { class: 'z-[9999]' }, message: { class: '!bg-transparent !border-0 !shadow-none !p-0 mb-3' } }">
    <template #container="{ message }">
      <GlassPanel strong :glow="false" padding="sm" class="flex w-[min(92vw,28rem)] items-start gap-3 shadow-xl" role="status" data-test="toast-dispositivo">
        <i :class="[ICONE[message.severity as string] ?? ICONE.info, 'mt-0.5 text-2xl', COLORI[message.severity as string] ?? COLORI.info]" aria-hidden="true" />
        <div class="min-w-0 flex-1">
          <p class="font-semibold text-text-primary">{{ message.summary }}</p>
          <p class="text-sm text-text-secondary">{{ message.detail }}</p>
        </div>
      </GlassPanel>
    </template>
  </Toast>
</template>

<script setup lang="ts">
// Avvisi del gruppo «device» (es. un quadro locale si è autenticato): scheda di vetro con icona per gravità. La forma dell'icona
// dice la gravità, non solo il colore (design-system.md, sezione 1).
const ICONE: Record<string, string> = {
  success: "fas fa-circle-check",
  warn: "fas fa-triangle-exclamation",
  error: "fas fa-circle-xmark",
  info: "fas fa-circle-info",
};
const COLORI: Record<string, string> = {
  success: "text-success-500",
  warn: "text-warning-500",
  error: "text-error-500",
  info: "text-accent",
};
</script>
